import { ApplicationConfig, ErrorHandler, LOCALE_ID } from '@angular/core';
import { provideRouter, withViewTransitions } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AirbrakeErrorHandler } from '@utils/error-handling/airbrake-error-handler';
import { provideOptimus } from '@openng/optimus-ui/config';
import { MockfjardsPreset } from './theme/mockfjards.preset';
import localeSv from '@angular/common/locales/sv';

registerLocaleData(localeSv, 'sv-SE');

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(routes, withViewTransitions()),
    provideAnimations(),
    provideOptimus({
      theme: {
        preset: MockfjardsPreset,
        options: { darkModeSelector: false }
      }
    }),
    { provide: ErrorHandler, useClass: AirbrakeErrorHandler},
    { provide: LOCALE_ID, useValue: 'sv-SE' }
  ]
};
